<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>

<script>
window.onload = function () {
    document.addEventListener("touchstart", function (event) {
        if (event.touches.length > 1) {
            event.preventDefault();
        }
    });
    document.addEventListener("gesturestart", function (event) {
        event.preventDefault();
    });
};

export default {
    name: "App",
};
</script>

<style>
* {
    margin: 0;
    padding: 0;
    list-style: none;
    box-sizing: border-box;
    font-family: "Microsoft YaHei";
    font-weight: normal;
    border: 0;
    outline-style: none;
    text-decoration: none;
    font-style: normal;
    /* color: #343434; */
}

img,
input {
    display: block;
}

body {
    /*padding-top: 90px;*/
}

.header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 999;
}

.header h3 {
    text-align: center;
    line-height: 90px;
    font-size: 34px;
}

.header img {
    width: 20px;
    position: absolute;
    top: 30px;
    left: 22px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue